import React from 'react';
import logoSvg from '../assets/logo.svg';

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <object data={logoSvg} type="image/svg+xml" width="160" height="40"></object>
            <p>Oyun Güvenlik Çözümleri & Bypass Uzmanı</p>
          </div>
          <div className="footer-links">
            <div className="link-group">
              <h3>Hızlı Bağlantılar</h3>
              <ul>
                <li><a href="#home">Ana Sayfa</a></li>
                <li><a href="#expertise">Hizmetler</a></li>
                <li><a href="#about">Hakkımızda</a></li>
                <li><a href="#projects">Ürünler</a></li>
                <li><a href="#references">Referanslar</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Kinfhertix. Tüm hakları saklıdır.</p>
          <div className="social-icons">
            <a href="#"><i className="fab fa-discord"></i></a>
            <a href="#"><i className="fab fa-telegram"></i></a>
            <a href="#"><i className="fab fa-github"></i></a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 